var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "YdDialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.showVisible,
        "append-to-body": "",
        width: "60%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.showVisible = $event
        },
        close: _vm.closeEdit,
        open: _vm.openEdit,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticStyle: { "margin-left": "30px", "margin-right": "10px" },
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            size: "mini",
            "label-position": "left",
            "label-width": "100px",
          },
        },
        [
          _c("div", { staticClass: "title-box" }, [_vm._v("基本信息")]),
          _c(
            "el-form-item",
            { attrs: { label: "活动名称", prop: "name" } },
            [
              _c("el-input", {
                staticStyle: { width: "300px" },
                attrs: {
                  type: "text",
                  placeholder: "不超过10个字",
                  maxlength: "10",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "隶属公司", prop: "merchantId" } },
            [
              _c("YdMerchantSelector", {
                attrs: {
                  styles: "width: 300px",
                  placeholder: "请选择隶属公司",
                },
                model: {
                  value: _vm.form.merchantId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "merchantId", $$v)
                  },
                  expression: "form.merchantId",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "活动时间", required: "" } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "200px" },
                attrs: {
                  format: "yyyy-MM-dd HH:mm:ss",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  type: "datetime",
                  placeholder: "开始日期",
                  "picker-options": _vm.pickerOptionStart(),
                },
                model: {
                  value: _vm.form.startTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "startTime", $$v)
                  },
                  expression: "form.startTime",
                },
              }),
              _c("span", [_vm._v(" - ")]),
              _c("el-date-picker", {
                staticStyle: { width: "200px" },
                attrs: {
                  format: "yyyy-MM-dd HH:mm:ss",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  type: "datetime",
                  placeholder: "结束日期",
                  "picker-options": _vm.pickerOptionEnd(),
                },
                model: {
                  value: _vm.form.endTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "endTime", $$v)
                  },
                  expression: "form.endTime",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
                "align-items": "center",
              },
            },
            [
              _c("div", { staticClass: "title-box" }, [_vm._v("活动奖励")]),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    icon: "el-icon-circle-plus-outline",
                    size: "mini",
                  },
                  on: { click: _vm.handleAddCoupon },
                },
                [_vm._v("添加优惠券/礼包")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "padding-top": "10px", "margin-bottom": "15px" } },
            [
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.couponItem,
                    border: "",
                    size: "mini",
                    "max-height": "280px",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "序号",
                      type: "index",
                      width: "50",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "优惠券名称",
                      align: "center",
                      prop: "name",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "所属礼包",
                      align: "center",
                      prop: "giftName",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "金额/个",
                      align: "center",
                      prop: "discountsMoney",
                      width: "80",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "剩余数量",
                      align: "center",
                      prop: "surplusNum",
                      width: "100",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "每次领取数量",
                      align: "center",
                      prop: "num",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("avue-input-number", {
                              staticStyle: { width: "8vw" },
                              attrs: { "min-rows": "0" },
                              model: {
                                value: scope.row.num,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "num", $$v)
                                },
                                expression: "scope.row.num",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.deletes(scope.$index)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "生成兑换码", prop: "redemptionCodeNum" } },
            [
              _c("el-input", {
                staticStyle: { width: "150px" },
                attrs: { type: "number" },
                model: {
                  value: _vm.form.redemptionCodeNum,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "redemptionCodeNum", $$v)
                  },
                  expression: "form.redemptionCodeNum",
                },
              }),
              _vm._v("份\n    "),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.closeEdit } }, [_vm._v("取 消")]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.save } },
            [_vm._v("保 存")]
          ),
        ],
        1
      ),
      _vm.selectVisible
        ? _c("select-coupon", {
            ref: "selectCoupon",
            on: { getCouponItem: _vm.getCouponItem },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }